
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/add-user",
      function () {
        return require("private-next-pages/user/add-user.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/add-user"])
      });
    }
  